import { render } from "./result.vue?vue&type=template&id=5f40212d&scoped=true"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"

import "./result.vue?vue&type=style&index=0&id=5f40212d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lq\\Desktop\\普康\\activity-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f40212d"]])

export default __exports__